import { cloneElement } from 'react';
import { AnimatePresence } from 'framer-motion';
import { useLocation, useOutlet } from 'react-router-dom';
import AppNavbar from './AppNavbar';
import Footer from './Footer';
import TopographicBackground from './background/TopographicBackground';

function Layout() {
  const location = useLocation();
  const outlet = useOutlet();

  return (
    <div className="App">
      <TopographicBackground />
      <AppNavbar className="fixed-navbar" />
      <main className="main-content">
        <AnimatePresence mode="wait">
          {outlet && cloneElement(outlet, { key: location.pathname })}
        </AnimatePresence>
      </main>
      <Footer />
    </div>
  );
}

export default Layout;
